import React from 'react';
import PropTypes from 'prop-types';

export const FormErrors = ({ errors }) => {
    return (
        <div className="errors-list">
            {Object.keys(errors).length > 0 && (
                <div
                    className="alert alert-danger d-flex flex-column align-items-stretch"
                    role="alert">
                    {Object.keys(errors).map((key) => {
                        return (
                            <small className="text-left" key={key}>
                                <i className="fas fa-exclamation me-2"></i>
                                {errors[key].message}
                            </small>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

FormErrors.propTypes = {
    errors: PropTypes.object.isRequired
};
